import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Dropzone from 'react-dropzone';
import style from './LogUploader.css';
export var LogUploader = /*#__PURE__*/function (_Component) {
  _inherits(LogUploader, _Component);

  var _super = _createSuper(LogUploader);

  function LogUploader() {
    var _this;

    _classCallCheck(this, LogUploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      message: 'Load log file...'
    });

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (files) {
      var file = files[0];
      var reader = new FileReader();

      reader.onload = function (e) {
        var content = e.target.result.trim();

        if (!_this.isLog(content)) {
          _this.setState({
            message: 'Invalid log file'
          });

          return;
        }

        _this.props.onLogFile(content);
      };

      reader.readAsText(file);
    });

    return _this;
  }

  _createClass(LogUploader, [{
    key: "isLog",
    value: function isLog(content) {
      return content[0] === '{' && content[content.length - 1] === '}';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dropStyle = {
        display: 'inline-block',
        margin: '5px'
      };
      return /*#__PURE__*/React.createElement(Dropzone, {
        multiple: false,
        accept: "text/*",
        className: "button",
        style: dropStyle,
        onDrop: this.onDrop
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps;
        return /*#__PURE__*/React.createElement("button", getRootProps(), _this2.state.message, /*#__PURE__*/React.createElement("input", getInputProps()));
      });
    }
  }]);

  return LogUploader;
}(Component);